export const MYALC_URL = "https://myalc.vivekcomputers.org";
export const EXAM_URL = "https://exam.vivekcomputers.org";

export const QUESTION_TYPES = {
  MULTI_CHOICE: "multi-choice",
  MULTI_SELECT: "multi-select",
};
